import React from 'react';
import Link from 'next/link';
import isEmpty from 'lodash/isEmpty';
import { QUERY_PARAMS } from 'consts';
import type { ArticleTag } from 'types';

const { ARTICLE_TAG_PARAM } = QUERY_PARAMS;

interface ArticleTagsProps {
  tags?: ArticleTag[];
  className?: string;
  /** When false, tags render as plain text (e.g. inside article card links). */
  asLinks?: boolean;
}

export function ArticleTags({
  tags = [],
  asLinks = true,
}: ArticleTagsProps): React.JSX.Element | null {
  if (isEmpty(tags)) {
    return null;
  }

  if (!asLinks) {
    return (
      <ul className="articleTags" aria-label="Article tags">
        {tags.map((tag) => (
          <li key={tag.slug} className="articleTags__tag">
            <span className="articleTags__link">{tag.name}</span>
          </li>
        ))}
      </ul>
    );
  }

  return (
    <ul className="articleTags" aria-label="Article tags">
      {tags.map((tag) => (
        <li key={tag.slug} className="articleTags__tag">
          <Link
            href={{
              pathname: '/articles',
              query: { [ARTICLE_TAG_PARAM]: tag.slug },
            }}
            className="articleTags__link"
          >
            {tag.name}
          </Link>
        </li>
      ))}
    </ul>
  );
}
